import { Link } from 'react-router-dom';
import { Users, Building2, ArrowRight } from 'lucide-react';

const services = [
  {
    id: 'figure-manageriali',
    icon: Users,
    title: 'Figure Manageriali Specializzate',
    description: 'Capi Cantiere, Project Manager, HSE Manager, Commissioning Manager e altre figure tecniche di alto profilo per i tuoi progetti.',
    cta: 'Scopri',
    link: '/servizi#manageriali',
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzIyMDYxNzB8MA&ixlib=rb-4.1.0&q=85&w=400'
  },
  {
    id: 'network-imprese',
    icon: Building2,
    title: 'Network di Imprese Subappaltatrici',
    description: 'Carpenteria metallica, montaggi meccanici, impianti elettrici, saldature certificate e manutenzione impiantistica.',
    cta: 'Scopri',
    link: '/servizi#network',
    image: 'https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3NzIyMDI4MDF8MA&ixlib=rb-4.1.0&q=85&w=400'
  }
];

export default function Services() {
  return (
    <section data-testid="services-section" className="py-20 md:py-32 bg-[#F5F5F7] noise-bg relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-left mb-16">
          <span className="text-xs font-bold uppercase tracking-widest text-[#E94560] mb-4 block">I Nostri Servizi</span>
          <h2 data-testid="services-title" className="text-3xl md:text-5xl font-bold text-[#1A1A2E] mb-4">
            Soluzioni per ogni esigenza
          </h2>
          <p className="text-lg text-[#555555] max-w-2xl">
            Offriamo servizi di intermediazione specializzati per il settore EPC e industriale.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service) => (
            <Link 
              key={service.id}
              to={service.link}
              data-testid={`service-card-${service.id}`}
              className="card-industrial group overflow-hidden"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A2E] to-transparent opacity-60"></div>
                <div className="absolute bottom-4 left-4">
                  <service.icon className="text-white w-12 h-12" strokeWidth={1.5} />
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold text-[#1A1A2E] mb-3 group-hover:text-[#E94560] transition-colors">
                  {service.title}
                </h3>
                <p className="text-[#555555] mb-6">
                  {service.description}
                </p>
                <span className="inline-flex items-center gap-2 text-[#27AE60] font-bold">
                  {service.cta}
                  <ArrowRight size={18} className="transition-transform group-hover:translate-x-2" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
